import React, { useEffect, useState, useContext } from 'react'
import { AppContext } from '../../contexts'
import PropTypes from 'prop-types'
import './_date-selector.scss'
import dayjs from 'dayjs'
import isToday from 'dayjs/plugin/isToday';
import { getStartOfWeek, getWeek } from '../../utils';

dayjs.extend(isToday);

const prev = <svg width="7" height="14" viewBox="0 0 7 14" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M6.99975 11.9999L1.99975 6.99994L6.99975 1.99994L5.58575 0.585938L0.58575 5.58594C-0.19525 6.36694 -0.19525 7.63294 0.58575 8.41394L5.58575 13.4139L6.99975 11.9999Z" fill="#868B91"/> </svg>;
const next = <svg width="7" height="14" viewBox="0 0 7 14" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M0 1.99994L5 6.99994L0 11.9999L1.414 13.4139L6.414 8.41394C7.195 7.63294 7.195 6.36694 6.414 5.58594L1.414 0.585938L0 1.99994Z" fill="#868B91"/> </svg>;

const DateSelector = ({ title, onWeekChange, enabledDays, loading, onSelect }) => {
  const { currentWeek, setCurrentWeek } = useContext(AppContext);
  const [isTouched, setIsTouched] = useState(false);

  const startOfWeek = getStartOfWeek(currentWeek);
  const handlePrev = setCurrentWeek.bind(null, currentWeek - 1);
  const handleNext = setCurrentWeek.bind(null, currentWeek + 1);

  const { days, months, years } = getWeek(startOfWeek);

  const handleChange = i => {
    onSelect(i);
    if (!isTouched) setIsTouched(true);
  };

  useEffect(() => {
    onWeekChange(startOfWeek);
  }, [currentWeek]);


  const renderDay = (day, i) => {
    const isDisabled = loading || day.isBefore(dayjs(), 'day') || !enabledDays?.includes?.(day.date());
    const isToday = day.isToday();
    let cssClass = 'date-selector__date';
    if (isDisabled) cssClass += ' date-selector__date--disabled';
    if (loading) cssClass += ' date-selector__date--loading';
    const formattedDate = day.format('DD-MM-YYYY');

    return (
      <li className={cssClass} key={formattedDate}>
        <label className="date-selector__date-label">
          <input data-testid="day" onChange={handleChange.bind(null, Number(day.format('D')))} type="radio" className="date-selector__date-input" name="date" disabled={isDisabled} />
          <span className="date-selector__day">{day.format('ddd')}</span>
          <span className="date-selector__number">{day.format('D')}</span>
        </label>
      </li>
    )
  }

  return (
    <div className="date-selector">
      {title && <h3 className="date-selector__title">{title}</h3>}
      <div className="date-selector__info-bar">
        <p className="date-selector__info">{months.join(' - ')}, {years.join(' - ')}</p>
        <div className="date-selector__nav">
          <button className="date-selector__arrow date-selector__arrow--before" onClick={handlePrev} disabled={currentWeek === 0 || loading ? true : false}>{prev}</button>
          <button className="date-selector__arrow date-selector__arrow--after" onClick={handleNext}  disabled={loading}>{next}</button>
        </div>
      </div>
      <ul className="date-selector__dates">{days.map(renderDay)}</ul>
    </div>
  )
}

DateSelector.propTypes = {
  title: PropTypes.string,
  onWeekChange: PropTypes.func,
  onSelect: PropTypes.func,
  enabledDays: PropTypes.arrayOf(PropTypes.number),
}

export default DateSelector
